/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceChallengeZoneLeaderEntry } from './SurfaceChallengeZoneLeaderEntry';
import {
    SurfaceChallengeZoneLeaderEntryFromJSON,
    SurfaceChallengeZoneLeaderEntryFromJSONTyped,
    SurfaceChallengeZoneLeaderEntryToJSON,
    SurfaceChallengeZoneLeaderEntryToJSONTyped,
} from './SurfaceChallengeZoneLeaderEntry';
import type { SurfaceChallengeZoneObjective } from './SurfaceChallengeZoneObjective';
import {
    SurfaceChallengeZoneObjectiveFromJSON,
    SurfaceChallengeZoneObjectiveFromJSONTyped,
    SurfaceChallengeZoneObjectiveToJSON,
    SurfaceChallengeZoneObjectiveToJSONTyped,
} from './SurfaceChallengeZoneObjective';
import type { SurfaceChallengeZoneMoreActivation } from './SurfaceChallengeZoneMoreActivation';
import {
    SurfaceChallengeZoneMoreActivationFromJSON,
    SurfaceChallengeZoneMoreActivationFromJSONTyped,
    SurfaceChallengeZoneMoreActivationToJSON,
    SurfaceChallengeZoneMoreActivationToJSONTyped,
} from './SurfaceChallengeZoneMoreActivation';
import type { SurfaceChallengeZoneBingoCell } from './SurfaceChallengeZoneBingoCell';
import {
    SurfaceChallengeZoneBingoCellFromJSON,
    SurfaceChallengeZoneBingoCellFromJSONTyped,
    SurfaceChallengeZoneBingoCellToJSON,
    SurfaceChallengeZoneBingoCellToJSONTyped,
} from './SurfaceChallengeZoneBingoCell';

/**
 * 
 * @export
 * @interface SurfaceChallengeZoneConfig
 */
export interface SurfaceChallengeZoneConfig {
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneConfig
     */
    variant: SurfaceChallengeZoneConfigVariantEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneConfig
     */
    brandLogoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneConfig
     */
    brandName?: string;
    /**
     * Display label e.g. "Scavenger Hunt"
     * @type {string}
     * @memberof SurfaceChallengeZoneConfig
     */
    challengeType?: string;
    /**
     * Epoch ms countdown end time
     * @type {number}
     * @memberof SurfaceChallengeZoneConfig
     */
    countdownEndAt?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneConfig
     */
    rewardIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneConfig
     */
    rewardLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneConfig
     */
    rewardDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneConfig
     */
    ctaText?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneConfig
     */
    ctaUrl?: string;
    /**
     * 
     * @type {Array<SurfaceChallengeZoneMoreActivation>}
     * @memberof SurfaceChallengeZoneConfig
     */
    moreActivations?: Array<SurfaceChallengeZoneMoreActivation>;
    /**
     * 
     * @type {Array<SurfaceChallengeZoneObjective>}
     * @memberof SurfaceChallengeZoneConfig
     */
    objectives?: Array<SurfaceChallengeZoneObjective>;
    /**
     * 
     * @type {Array<SurfaceChallengeZoneLeaderEntry>}
     * @memberof SurfaceChallengeZoneConfig
     */
    leaderboardEntries?: Array<SurfaceChallengeZoneLeaderEntry>;
    /**
     * 
     * @type {Array<SurfaceChallengeZoneBingoCell>}
     * @memberof SurfaceChallengeZoneConfig
     */
    bingoCells?: Array<SurfaceChallengeZoneBingoCell>;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneConfig
     */
    bingoPerLineReward?: string;
    /**
     * Live mode — fetches from GamificationModel API when demoMode is false
     * @type {string}
     * @memberof SurfaceChallengeZoneConfig
     */
    gamificationModelId?: string;
}


/**
 * @export
 */
export const SurfaceChallengeZoneConfigVariantEnum = {
    SCAVENGER_HUNT: 'SCAVENGER_HUNT',
    LEADERBOARD_MINI: 'LEADERBOARD_MINI',
    BINGO_MINI: 'BINGO_MINI'
} as const;
export type SurfaceChallengeZoneConfigVariantEnum = typeof SurfaceChallengeZoneConfigVariantEnum[keyof typeof SurfaceChallengeZoneConfigVariantEnum];


/**
 * Check if a given object implements the SurfaceChallengeZoneConfig interface.
 */
export function instanceOfSurfaceChallengeZoneConfig(value: object): value is SurfaceChallengeZoneConfig {
    if (!('variant' in value) || value['variant'] === undefined) return false;
    return true;
}

export function SurfaceChallengeZoneConfigFromJSON(json: any): SurfaceChallengeZoneConfig {
    return SurfaceChallengeZoneConfigFromJSONTyped(json, false);
}

export function SurfaceChallengeZoneConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceChallengeZoneConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'variant': json['variant'],
        'brandLogoUrl': json['brandLogoUrl'] == null ? undefined : json['brandLogoUrl'],
        'brandName': json['brandName'] == null ? undefined : json['brandName'],
        'challengeType': json['challengeType'] == null ? undefined : json['challengeType'],
        'countdownEndAt': json['countdownEndAt'] == null ? undefined : json['countdownEndAt'],
        'rewardIcon': json['rewardIcon'] == null ? undefined : json['rewardIcon'],
        'rewardLabel': json['rewardLabel'] == null ? undefined : json['rewardLabel'],
        'rewardDescription': json['rewardDescription'] == null ? undefined : json['rewardDescription'],
        'ctaText': json['ctaText'] == null ? undefined : json['ctaText'],
        'ctaUrl': json['ctaUrl'] == null ? undefined : json['ctaUrl'],
        'moreActivations': json['moreActivations'] == null ? undefined : ((json['moreActivations'] as Array<any>).map(SurfaceChallengeZoneMoreActivationFromJSON)),
        'objectives': json['objectives'] == null ? undefined : ((json['objectives'] as Array<any>).map(SurfaceChallengeZoneObjectiveFromJSON)),
        'leaderboardEntries': json['leaderboardEntries'] == null ? undefined : ((json['leaderboardEntries'] as Array<any>).map(SurfaceChallengeZoneLeaderEntryFromJSON)),
        'bingoCells': json['bingoCells'] == null ? undefined : ((json['bingoCells'] as Array<any>).map(SurfaceChallengeZoneBingoCellFromJSON)),
        'bingoPerLineReward': json['bingoPerLineReward'] == null ? undefined : json['bingoPerLineReward'],
        'gamificationModelId': json['gamificationModelId'] == null ? undefined : json['gamificationModelId'],
    };
}

export function SurfaceChallengeZoneConfigToJSON(json: any): SurfaceChallengeZoneConfig {
    return SurfaceChallengeZoneConfigToJSONTyped(json, false);
}

export function SurfaceChallengeZoneConfigToJSONTyped(value?: SurfaceChallengeZoneConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'variant': value['variant'],
        'brandLogoUrl': value['brandLogoUrl'],
        'brandName': value['brandName'],
        'challengeType': value['challengeType'],
        'countdownEndAt': value['countdownEndAt'],
        'rewardIcon': value['rewardIcon'],
        'rewardLabel': value['rewardLabel'],
        'rewardDescription': value['rewardDescription'],
        'ctaText': value['ctaText'],
        'ctaUrl': value['ctaUrl'],
        'moreActivations': value['moreActivations'] == null ? undefined : ((value['moreActivations'] as Array<any>).map(SurfaceChallengeZoneMoreActivationToJSON)),
        'objectives': value['objectives'] == null ? undefined : ((value['objectives'] as Array<any>).map(SurfaceChallengeZoneObjectiveToJSON)),
        'leaderboardEntries': value['leaderboardEntries'] == null ? undefined : ((value['leaderboardEntries'] as Array<any>).map(SurfaceChallengeZoneLeaderEntryToJSON)),
        'bingoCells': value['bingoCells'] == null ? undefined : ((value['bingoCells'] as Array<any>).map(SurfaceChallengeZoneBingoCellToJSON)),
        'bingoPerLineReward': value['bingoPerLineReward'],
        'gamificationModelId': value['gamificationModelId'],
    };
}

